import React, { useState } from 'react';

/**
 * "Or paste a link" for every picture box (Jenn, 2026-10-29: "every place a
 * picture can be added takes BOTH ways: upload from your device AND paste a
 * link (like Google Drive)"). A Google Drive "Copy link" (file shared as
 * Anyone with the link) is turned into its picture address, the same way
 * server/src/utils/driveImage.js does.
 */
const DRIVE_FILE_PATTERNS = [
  /drive\.google\.com\/file\/d\/([\w-]+)/,
  /drive\.google\.com\/open\?id=([\w-]+)/,
  /drive\.google\.com\/uc\?[^ ]*[?&]id=([\w-]+)/,
];
export const imageLink = (url) => {
  const u = String(url || '').trim();
  for (const re of DRIVE_FILE_PATTERNS) {
    const m = u.match(re);
    if (m) return `https://drive.google.com/thumbnail?id=${m[1]}&sz=w1600`;
  }
  return u;
};

export default function ImageLinkInput({ onLink, disabled, buttonLabel = 'Use link' }) {
  const [draft, setDraft] = useState('');
  const [error, setError] = useState(null);
  const use = () => {
    const url = imageLink(draft);
    if (!/^https:\/\/\S+$/i.test(url)) { setError('Paste a link that starts with https://'); return; }
    if (/drive\.google\.com\/drive\/folders/.test(url)) { setError("That's a folder link. Open the picture in Drive and copy its own link."); return; }
    setError(null);
    onLink(url);
    setDraft('');
  };
  return (
    <div className="mt-1.5" onClick={e => e.stopPropagation()}>
      <div className="flex gap-1.5">
        <input value={draft} onChange={e => setDraft(e.target.value)} disabled={disabled}
          onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); use(); } }}
          placeholder="…or paste a link (Google Drive or any picture link)"
          className="flex-1 min-w-0 border border-gray-200 rounded-lg px-2 py-1.5 text-xs focus:outline-none focus:ring-2 focus:ring-reset-terracotta" />
        <button type="button" onClick={use} disabled={disabled || !draft.trim()}
          className="text-xs font-medium px-2.5 rounded-lg border border-gray-200 text-reset-brown hover:border-reset-terracotta disabled:opacity-40 shrink-0">{buttonLabel}</button>
      </div>
      {error && <p className="text-[11px] text-reset-brown mt-1">{error}</p>}
    </div>
  );
}
